/**
 * Static catalog of HSE / OHS external resources rendered by
 * <flexi-additional-resources>. Order matters and matches Appendix C of
 * ISSUE_FLEXI_DIGITAL_ONBOARDING_BACKEND.md (the umbrella spec).
 *
 * Backend exposes nothing for Phase 1 — Admin CRUD is deferred. To change
 * the catalog content, edit this file.
 *
 * Each entry has:
 *  - `i18nKey`  → translation key under `FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.LINKS.*`
 *                 used for the link label (also doubles as the fallback if the
 *                 translation is missing).
 *  - `url`      → external destination (always opens in a new tab).
 *  - `issuer`   → optional source / publisher chip rendered next to the title.
 *                 i18n key under `FLEXI_ONBOARDING.ADDITIONAL_RESOURCES.ISSUERS.*`.
 *  - `domain`   → derived hostname shown under the title (computed at render time).
 */
export interface AdditionalResourceLink {
  /** Translation key for the link label (under `…ADDITIONAL_RESOURCES.LINKS`). */
  i18nKey: string;
  /** External target URL. */
  url: string;
  /** Optional translation key for the issuer (under `…ADDITIONAL_RESOURCES.ISSUERS`). */
  issuer?: string;
}

export const ADDITIONAL_RESOURCES: AdditionalResourceLink[] = [
  {
    i18nKey: 'SMART_EXERCISE',
    url: 'https://www.helsedirektoratet.no/tema/fysisk-aktivitet/smart-trening-pa-jobben',
    issuer: 'HEALTH_DIRECTORATE',
  },
  {
    i18nKey: 'PSYCHOSOCIAL',
    url: 'https://www.arbeidstilsynet.no/tema/psykososialt-arbeidsmiljo/',
    issuer: 'LABOUR_INSPECTION',
  },
  {
    i18nKey: 'GOOD_DAY_AT_WORK',
    url: 'https://enbradagpajobb.no',
  },
  {
    i18nKey: 'WORKING_ENVIRONMENT_PORTAL',
    url: 'https://www.arbeidsmiljoportalen.no',
  },
  {
    i18nKey: 'MUSCULOSKELETAL',
    url: 'https://www.arbeidstilsynet.no/tema/muskel--og-skjelettplager/',
    issuer: 'LABOUR_INSPECTION',
  },
  {
    i18nKey: 'ARBEIDSTILSYNET',
    url: 'https://www.arbeidstilsynet.no',
  },
  {
    i18nKey: 'DSB',
    url: 'https://www.dsb.no',
  },
  {
    i18nKey: 'NSO',
    url: 'https://www.nso.no',
  },
  {
    i18nKey: 'HELSEDIREKTORATET',
    url: 'https://www.helsedirektoratet.no',
  },
];
